enum LiveState {
  NONE = 'live-state/none',
  INITIAL = 'live-state/initial',
  NOT_SYNC = 'live-state/not-sync',
  SYNC = 'live-state/sync',
  ENDED = 'live-state/ended',
}

export default LiveState;
